import { styled } from '@mui/material/styles'
import { Box, Button, Typography } from '@mui/material'
import MuiButton from '../../../../../components/muiButton'

export const Wrapper = styled(Box)(`
  width:800px;
  & .login-button {
    border-radius: 4px;
  }
`)

export const LoginButton = styled(MuiButton)(`
  margin-top:10px;
  margin-left: 0 !important;
`)

export const Title = styled(Typography)(`
  margin-top: -10px;
  padding-bottom: 30px;
  font-style: normal;
  font-weight: 400; // 300;
  font-size: 20px;
  line-height: 30px;
`)

export const InputWrap = styled(Box)(`
  // height: 70px;
  padding-bottom: 10px;
  & .formLabel {
    padding-bottom:5px;
  }
`)

export const ButtonWrapper = styled(Box)(`
  width:100%;
  display:flex;
  justify-content:end;
`)

export const SuggestionWrapper = styled(Box)(`
    width: 80%;
    display:flex;
    align-items: center;
    justify-content: center;
    flex-wrap:wrap;
    margin-top: 32px;
    gap: 16px;
`)

export const SuggestionInputWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  maxHeight: 'calc(100vh - 350px)',
  overflowY: 'auto',
  '& .formLabel': {
    color: theme.palette.text.primary,
  },
}))

export const SuggestionLink = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  // textWrap: 'nowrap',
  borderRadius: '4px',
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '20px',
  border: `1px ${theme.palette.primary.light} solid`,
  padding: '4px 12px',
  cursor: 'pointer',
  background: theme.palette.background.primaryLightest,
  ':disabled': {
    cursor: 'default',
  },
  '&:hover': {
    background: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(42, 42, 41, 1)',
  },
  '&:active': {
    background: theme.palette.mode === 'light' ? '#E4EEFB' : '#454545',
  },
  height : 'auto',
  minHeight : '35px',
  textWrap : 'auto',
  '& svg' : {
    minWidth: 'fit-content',
  }
}))

export const SuggestionButtonWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginTop: '10px',
  '& .suggestions-text': {
    fontSize: '14px',
    color: theme.palette.mode === 'light' ? '#095BBD' : '#CEDEF2',
  },
}))

export const LoaderInitiating = styled(Box)(`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  padding: 9px 10px;

  position: fixed;
  bottom: 151px;
  left: 60px;
  background: #fff;
  border-radius: 8px;
  z-index: 10;

  visibility: hidden;
`)
